import { useSmallScreen } from '@/hooks/useWindowDimension';
import { Stack, Group, Text, Box } from '@mantine/core';
import { useTheme } from '@/assets/styles/themeMantine';
import { useClientTerminology } from '@/hooks/useClientTerminology';

// Matches the `fuel_hazard_colormap` anchors: dark purple → light purple →
// orange → gold across the low-to-high hazard range.
const FUEL_HAZARD_GRADIENT =
  'linear-gradient(to right, #722AA2, #AA49AD, #F09553, #F9D86A)';

export const FuelHazardLegend = () => {
  const isSmallScreen = useSmallScreen();
  const theme = useTheme();
  const { formatMessage } = useClientTerminology();

  return (
    <Stack gap="xs" data-testid="fuel-hazard-legend">
      {!isSmallScreen && (
        <Text
          fw={theme.other.typography.weight.medium}
          size="sm"
          data-testid="fuel-hazard-legend-title"
        >
          {formatMessage({ id: 'map.legend.fuelHazard.title' })}
        </Text>
      )}
      <Box>
        <Box
          h={8}
          w="100%"
          style={{ background: FUEL_HAZARD_GRADIENT }}
          data-testid="fuel-hazard-gradient-bar"
        />
        <Group justify="space-between" mt={4}>
          <Box>
            <Text size="xs" c="dimmed" lh="16px">
              {formatMessage({ id: 'map.legend.fuelHazard.low' })}
            </Text>
            <Text size="xs" c="dimmed" lh="16px">
              {formatMessage({ id: 'map.legend.fuelHazard.scale' })}
            </Text>
          </Box>
          <Box style={{ textAlign: 'right' }}>
            <Text size="xs" c="dimmed" lh="16px">
              {formatMessage({ id: 'map.legend.fuelHazard.high' })}
            </Text>
            <Text size="xs" c="dimmed" lh="16px">
              {formatMessage({ id: 'map.legend.fuelHazard.scale' })}
            </Text>
          </Box>
        </Group>
      </Box>
    </Stack>
  );
};
